import { numberFmt } from "@/util/numberFmt"

export default function BarGauge({
  actual,
  budget,
  days,
  monthDays,
}: {
  actual: number
  budget: number
  days: number
  monthDays: number
}) {
  const pace = budget * (days / monthDays)

  const baseHeight = 120
  const baseWidth = 60
  const actualHeight = (Math.min(actual, budget) / budget) * baseHeight

  const barOffset = 20
  const barXOffset = 55
  const textOffset = actual / budget > 0.3 ? 20 + barOffset : -5 + barOffset

  const paceY = baseHeight + barOffset - baseHeight * (pace / budget)
  const percentToPace = pace > 0 ? actual / pace : 0

  return (
    <div className="w-full grow flex justify-center">
      <svg className="max-w-[300px]" height="98%" viewBox="0 0 220 150">
        <g>
          <rect
            width={baseWidth}
            height={baseHeight}
            fill="var(--chart-2)"
            x={barXOffset}
            y={barOffset}
          />
          <rect
            width={baseWidth}
            height={actualHeight}
            fill="var(--chart-1)"
            x={barXOffset}
            y={baseHeight - actualHeight + barOffset}
          />
        </g>
        <g>
          <path
            d={`M${barXOffset} ${paceY} L${barXOffset + baseWidth + 20} ${paceY}`}
            stroke={actual < pace ? "var(--status-bad)" : "var(--status-good)"}
            strokeWidth={2}
            strokeDasharray="6 4"
          />
          <text
            x={barXOffset + baseWidth + 20}
            y={paceY}
            fill={actual < pace ? "var(--status-bad)" : "var(--status-good)"}
            className="font-semibold select-none text-xs"
            dominantBaseline="central"
          >
            {numberFmt(pace)}
          </text>
          <text
            x={barXOffset + baseWidth + 20}
            y={paceY + 10}
            fill={actual < pace ? "var(--status-bad)" : "var(--status-good)"}
            className="select-none text-[8px]"
            dominantBaseline="central"
          >
            (pacer) {Math.round(percentToPace * 100)}%
          </text>
        </g>
        <g>
          <text
            textAnchor="middle"
            x={baseWidth / 2 + barXOffset}
            y={10}
            className="font-semibold select-none"
            fill="var(--foreground)"
            dominantBaseline="central"
          >
            {numberFmt(budget)}
          </text>
          <text
            textAnchor="start"
            dominantBaseline="central"
            x={baseWidth + barXOffset}
            y={10}
            className="select-none text-[8px]"
            fill="var(--foreground)"
          >
            (target)
          </text>
        </g>
        <g>
          <text
            textAnchor="middle"
            x={barXOffset + baseWidth / 2}
            fill="white"
            y={baseHeight - actualHeight + textOffset}
            className="font-semibold select-none"
          >
            {numberFmt(actual)}
          </text>
          <text
            textAnchor="middle"
            x={barXOffset + baseWidth / 2}
            fill="white"
            y={baseHeight - actualHeight + textOffset + (actual / budget > 0.3 ? 10 : -15)}
            className="select-none text-[8px]"
          >
            (actual)
          </text>
        </g>
      </svg>
    </div>
  )
}
